import styles from './Input.module.css'

const Input = ({
  label,
  id,
  placeHolder,
  onBeforeInput,
  value,
  inputRef,
  type = 'text',
}) => {
  const inputHandler = () => {
    onBeforeInput && onBeforeInput()
  }
  const handleChange = (e) => {
    if (type === 'password') {
      e.preventDefault()
    }
  }

  return (
    <div className={styles.wrapper}>
      {label && <label htmlFor={id}>{label}</label>}
      <input
        id={id}
        type={type}
        onBeforeInput={inputHandler}
        value={value}
        placeholder={placeHolder}
        ref={inputRef}
        autoFocus
        onCut={handleChange}
        onCopy={handleChange}
        onPaste={handleChange}
      />
    </div>
  )
}

export default Input
